/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Styles from './Boleto25PassoaPasso.css';
import Container from '../../atoms/Container/Container';
import CustomEmblaCarousel from '../CustomEmblaCarousel/CustomEmblaCarousel';
import RedButton from '../../atoms/RedButton/RedButton';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

function Boleto25PassoaPasso() {
  const [showMsg, setShowMsg] = useState(false);
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }

  return (
    <>
      <section id="boleto-passo-a-passo">
        <img
          className="boleto-logo-santander"
          src="assets/boleto25/Santander.svg"
          alt="logo santander"
        />
        <ContainerHome24 className="ctn-slide">
          <h3 className="boleto-passo-a-passo-title">
            Confira o passo a passo para gerar a <b>2ª via do seu boleto Santander</b>
          </h3>
          <div className="boleto-passo-a-passo-mobile">
            <CustomEmblaCarousel enableBullets bulletCount={width <= 992 ? 5 : 2}>
              {({ className }) => (
                <>
                  <div className={`slide boleto-passo-a-passo-card ${className}`}>
                    <img
                      className="boleto-passo-a-passo-card-img"
                      src="assets/boleto25/ic_account_people.svg"
                      alt=""
                    />
                    <p className="boleto-passo-a-passo-card-text">
                      1. Acesse a sua <b>Área do Cliente</b> no site.
                    </p>
                    <div className="separador-slide" />
                  </div>
                  <div className={`slide boleto-passo-a-passo-card ${className}`}>
                    <img
                      className="boleto-passo-a-passo-card-img"
                      src="assets/boleto25/ic_document_contract.svg"
                      alt=""
                    />
                    <p className="boleto-passo-a-passo-card-text">
                      2. Selecione seu <b>contrato</b>.
                    </p>
                    <div className="separador-slide" />
                  </div>
                  <div className={`slide boleto-passo-a-passo-card ${className}`}>
                    <img
                      className="boleto-passo-a-passo-card-img"
                      src="assets/boleto25/ic_mobile_recharge.svg"
                      alt=""
                    />
                    <p className="boleto-passo-a-passo-card-text">
                      3. Clique em <b>mostrar parcelas</b>.
                    </p>
                    <div className="separador-slide" />
                  </div>
                  <div className={`slide boleto-passo-a-passo-card ${className}`}>
                    <img
                      className="boleto-passo-a-passo-card-img"
                      src="assets/boleto25/ic_bill_payment.svg"
                      alt=""
                    />
                    <p className="boleto-passo-a-passo-card-text">
                      4. Selecione a(s) <b>parcela(s) desejada(s)</b>.
                    </p>
                    <div className="separador-slide" />
                  </div>
                  <div className={`slide boleto-passo-a-passo-card ${className}`}>
                    <img
                      className="boleto-passo-a-passo-card-img"
                      src="assets/boleto25/ic_levy_received.svg"
                      alt=""
                    />
                    <p className="boleto-passo-a-passo-card-text">
                      5. Pronto! Copie o <b>código de barras</b> ou <b>imprima o PDF</b> para
                      realizar o pagamento.
                    </p>
                  </div>
                </>
              )}
            </CustomEmblaCarousel>
          </div>
          <div className="boleto-passo-a-passo-desktop">
            <div className={`slide boleto-passo-a-passo-card`}>
              <img
                className="boleto-passo-a-passo-card-img"
                src="assets/boleto25/ic_account_people.svg"
                alt=""
              />
              <p className="boleto-passo-a-passo-card-text">
                1. Acesse a sua <b>Área do Cliente</b> no site.
              </p>
              <div className="separador-slide" />
            </div>
            <div className={`slide boleto-passo-a-passo-card`}>
              <img
                className="boleto-passo-a-passo-card-img"
                src="assets/boleto25/ic_document_contract.svg"
                alt=""
              />
              <p className="boleto-passo-a-passo-card-text">
                2. Selecione seu <b>contrato</b>.
              </p>
              <div className="separador-slide" />
            </div>
            <div className={`slide boleto-passo-a-passo-card`}>
              <img
                className="boleto-passo-a-passo-card-img"
                src="assets/boleto25/ic_mobile_recharge.svg"
                alt=""
              />
              <p className="boleto-passo-a-passo-card-text">
                3. Clique em <br />
                <b>mostrar parcelas</b>.
              </p>
              <div className="separador-slide" />
            </div>
            <div className={`slide boleto-passo-a-passo-card`}>
              <img
                className="boleto-passo-a-passo-card-img"
                src="assets/boleto25/ic_bill_payment.svg"
                alt=""
              />
              <p className="boleto-passo-a-passo-card-text">
                4. Selecione a(s) <b>parcela(s) desejada(s)</b>.
              </p>
              <div className="separador-slide" />
            </div>
            <div className={`slide boleto-passo-a-passo-card`}>
              <img
                className="boleto-passo-a-passo-card-img"
                src="assets/boleto25/ic_levy_received.svg"
                alt=""
              />
              <p className="boleto-passo-a-passo-card-text">
                5. Pronto! Copie o <b>código de barras</b> ou <b>imprima o PDF</b> para realizar o
                pagamento.
              </p>
            </div>
          </div>
          <RedButton
            href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF"
            id="passo-a-passo-gerar-boleto"
            wide
            target="_blank"
            rel="noopener"
          >
            Gerar boleto
          </RedButton>
        </ContainerHome24>
      </section>
      <section id="boleto-whats-app-desk">
        <ContainerHome24>
          <div className="whats-app-textos">
            <h3 className="whats-app-titulo">
              Você também pode gerar a 2ª via do seu <b>boleto pelo WhatsApp</b>
            </h3>
            <p className="whats-app-texto">
              Você sabia que é possível gerar seus boletos através do WhatsApp?
              <br />
              Basta{' '}
              <a
                href="https://www.santander.com.br/hotsite/santanderfinanciamentos/sandbox.html?ori=portalSF&int_source=lp-boleto&redirect=https://api.whatsapp.com/send?phone=551140049090&text=Ol%C3%A1%20Santander%20Financiamentos"
                target="_blank"
                rel="noopener"
              >
                acessar seu WhatsApp<div className="is-desk"> Web</div>
              </a>{' '}
              e emitir a 2ª via de forma rápida e fácil.
              <br />
              <br />
              <b>Praticidade e segurança</b> de onde estiver.
            </p>
          </div>
          {/* <img
            src="assets/boleto25/qrcode-whatsapp-santander.png"
            className="whats-app-qrcode"
            alt="qr code do WhatsApp de Boletos Santander"
          /> */}
        </ContainerHome24>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default Boleto25PassoaPasso;
